import React from "react";
import { apiCustomerBaru, formatApiErrorDetail } from "@/lib/api";
import { Loader2, UserPlus } from "lucide-react";
import * as W from "@/lib/waktu";

// owner 2026-10-15 (TAMBAHAN-OWNER-OKT A4): Kasir/CS may create Reseller/Member customers
// without approval; the owner checks the new customers per tier (who created them).
const TIPE = [["", "Semua tipe"], ["ENDUSER", "Enduser"], ["RESELLER", "Reseller"], ["MEMBER", "Member"]];
const LABEL = Object.fromEntries(TIPE);
const inputCls = "rounded-lg border border-slate-700 bg-slate-950 px-2 py-1.5 text-sm text-slate-100";

export default function CustomerBaruPanel() {
  const hari = W.hariIni();
  const [f, setF] = React.useState({ dari: `${hari.slice(0, 8)}01`, sampai: hari, tipe: "" });
  const [d, setD] = React.useState(null);
  const [error, setError] = React.useState(null);
  React.useEffect(() => {
    setError(null);
    apiCustomerBaru(Object.fromEntries(Object.entries(f).filter(([, v]) => v))).then(setD)
      .catch((e) => setError(formatApiErrorDetail(e.response?.data?.detail) || e.message));
  }, [f]);
  return (
    <section data-testid="customer-baru" className="rounded-xl border border-slate-800 bg-slate-900/60 p-4 space-y-3">
      <div className="flex flex-wrap items-end gap-2">
        <h2 className="mr-auto flex items-center gap-2 text-[15px] font-bold text-soq-biru-tua"><UserPlus size={16} /> Customer baru per tipe <span className="text-xs font-normal text-slate-500">(hanya Owner)</span></h2>
        <label className="text-xs text-slate-400">Dari <input data-testid="cb-dari" type="date" value={f.dari} onChange={(e) => setF({ ...f, dari: e.target.value })} className={inputCls} /></label>
        <label className="text-xs text-slate-400">Sampai <input data-testid="cb-sampai" type="date" value={f.sampai} onChange={(e) => setF({ ...f, sampai: e.target.value })} className={inputCls} /></label>
        <select data-testid="cb-tipe" value={f.tipe} onChange={(e) => setF({ ...f, tipe: e.target.value })} className={inputCls}>
          {TIPE.map(([k, l]) => <option key={k} value={k}>{l}</option>)}</select>
      </div>
      {error && <p className="text-sm text-red-600">{error}</p>}
      {!d && !error && <Loader2 size={16} className="animate-spin text-slate-400" />}
      {d && (<>
        <div data-testid="cb-per-tipe" className="flex flex-wrap gap-2 text-sm">
          {["ENDUSER", "RESELLER", "MEMBER"].map((t) => (
            <span key={t} data-testid={`cb-jumlah-${t}`} className="rounded-full border border-slate-700 px-3 py-1">{LABEL[t]}: <b>{d.per_tipe[t] || 0}</b></span>))}
          <span className="self-center text-xs text-slate-500">total {d.jumlah} customer baru</span>
        </div>
        <div className="max-h-80 overflow-auto">
          <table data-testid="cb-table" className="w-full text-sm">
            <thead><tr className="text-left text-xs font-semibold text-slate-500 border-b border-slate-800">
              <th className="px-3 py-2">Dibuat</th><th className="px-3 py-2">Kode</th><th className="px-3 py-2">Nama</th><th className="px-3 py-2">Tipe</th><th className="px-3 py-2">Dibuat oleh</th></tr></thead>
            <tbody>
              {d.rows.map((c) => (
                <tr key={c.id} data-testid={`cb-row-${c.kode_customer}`} className="border-b border-slate-800/60">
                  <td className="px-3 py-2 font-mono text-xs">{W.waktu(c.created_at)}</td><td className="px-3 py-2 font-mono text-amber-300">{c.kode_customer}</td>
                  <td className="px-3 py-2">{c.nama}</td>
                  <td className="px-3 py-2"><span className={`rounded px-2 py-0.5 text-[11px] font-semibold ${c.tipe_customer === "ENDUSER" ? "bg-slate-500/15" : "bg-amber-500/20 text-amber-700"}`}>{LABEL[c.tipe_customer]}</span></td>
                  <td className="px-3 py-2 text-xs">{c.dibuat_oleh}</td>
                </tr>
              ))}
              {d.rows.length === 0 && <tr><td colSpan={5} className="px-3 py-6 text-center text-slate-500">Tidak ada customer baru pada rentang ini.</td></tr>}
            </tbody>
          </table>
        </div>
      </>)}
    </section>
  );
}
